import type { ConfidenceOptions } from '@spotify-confidence/sdk';

export const FLAG_RESOLVER_PROXY_BASE_URL = '/api/flag-resolver';

const FLAG_RESOLVER_PROXY_HOSTS = [
  'app.confidence.spotify.com',
  'confidence.spotify.net',
];

type FlagResolverProxyOptions = Pick<
  ConfidenceOptions,
  'resolveBaseUrl' | 'applyBaseUrl'
>;

export const getFlagResolverProxyOptions = (
  hostname: string,
  origin: string,
): FlagResolverProxyOptions | Record<string, never> =>
  FLAG_RESOLVER_PROXY_HOSTS.includes(hostname)
    ? {
        resolveBaseUrl: `${origin}${FLAG_RESOLVER_PROXY_BASE_URL}`,
        applyBaseUrl: `${origin}${FLAG_RESOLVER_PROXY_BASE_URL}`,
      }
    : {};
